import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=37591465&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseTitle.vue?vue&type=style&index=0&id=37591465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37591465",
  null
  
)

export default component.exports